export const ITEM_STATUS = {
  RECEIVED_ORDER: "Received Order",
  ITEM_CREATED: "Item Created",
  PARTIAL_DELIVERY: "Partial Delivery",
  COMPLETE_DELIVERY: "Completed Delivery",
  CANCEL: "Cancelled (93)"
};
export const getAllowEditMap = (orderTypeS, id) => {
  const allowEditMap = {
    quantity: orderTypeS
      ? new Set([ITEM_STATUS.COMPLETE_DELIVERY, ITEM_STATUS.CANCEL])
      : new Set([ITEM_STATUS.CANCEL]),
    batchNo: new Set([
      ITEM_STATUS.PARTIAL_DELIVERY,
      ITEM_STATUS.COMPLETE_DELIVERY,
      ITEM_STATUS.CANCEL
    ]),
    salesUnit: new Set([
      ITEM_STATUS.PARTIAL_DELIVERY,
      ITEM_STATUS.COMPLETE_DELIVERY,
      ITEM_STATUS.CANCEL
    ]),
    plant: orderTypeS
      ? new Set([
          ITEM_STATUS.ITEM_CREATED,
          ITEM_STATUS.PARTIAL_DELIVERY,
          ITEM_STATUS.COMPLETE_DELIVERY,
          ITEM_STATUS.CANCEL
        ])
      : new Set([
          ITEM_STATUS.PARTIAL_DELIVERY,
          ITEM_STATUS.COMPLETE_DELIVERY,
          ITEM_STATUS.CANCEL
        ]),
    requestDate: orderTypeS
      ? new Set([ITEM_STATUS.COMPLETE_DELIVERY, ITEM_STATUS.CANCEL])
      : new Set([ITEM_STATUS.CANCEL]),
    pricePerUnit: orderTypeS
      ? new Set([
          ITEM_STATUS.ITEM_CREATED,
          ITEM_STATUS.PARTIAL_DELIVERY,
          ITEM_STATUS.COMPLETE_DELIVERY,
          ITEM_STATUS.CANCEL
        ])
      : new Set([
          ITEM_STATUS.PARTIAL_DELIVERY,
          ITEM_STATUS.COMPLETE_DELIVERY,
          ITEM_STATUS.CANCEL
        ]),
    priceDate: orderTypeS
      ? new Set([
          ITEM_STATUS.ITEM_CREATED,
          ITEM_STATUS.PARTIAL_DELIVERY,
          ITEM_STATUS.COMPLETE_DELIVERY,
          ITEM_STATUS.CANCEL
        ])
      : new Set([
          ITEM_STATUS.PARTIAL_DELIVERY,
          ITEM_STATUS.COMPLETE_DELIVERY,
          ITEM_STATUS.CANCEL
        ]),
    paymentTermItem: orderTypeS
      ? new Set([
          ITEM_STATUS.ITEM_CREATED,
          ITEM_STATUS.PARTIAL_DELIVERY,
          ITEM_STATUS.COMPLETE_DELIVERY,
          ITEM_STATUS.CANCEL
        ])
      : new Set([
          ITEM_STATUS.PARTIAL_DELIVERY,
          ITEM_STATUS.COMPLETE_DELIVERY,
          ITEM_STATUS.CANCEL
        ]),
    productionFlag: new Set([
      ITEM_STATUS.PARTIAL_DELIVERY,
      ITEM_STATUS.COMPLETE_DELIVERY,
      ITEM_STATUS.CANCEL
    ]),
    poDetails: new Set([ITEM_STATUS.CANCEL]),
    poItemNumber: new Set([ITEM_STATUS.CANCEL]),
    saleQtyFactor: new Set([
      ITEM_STATUS.PARTIAL_DELIVERY,
      ITEM_STATUS.COMPLETE_DELIVERY,
      ITEM_STATUS.CANCEL
    ]),
    shippingPoint: new Set([ITEM_STATUS.COMPLETE_DELIVERY, ITEM_STATUS.CANCEL]),
    deliveryTolerance: orderTypeS
      ? new Set([
          ITEM_STATUS.ITEM_CREATED,
          ITEM_STATUS.PARTIAL_DELIVERY,
          ITEM_STATUS.COMPLETE_DELIVERY,
          ITEM_STATUS.CANCEL
        ])
      : new Set([ITEM_STATUS.CANCEL]),
    shipTo: new Set([ITEM_STATUS.CANCEL]),
    internalCommentsToWarehouse: new Set([ITEM_STATUS.CANCEL]),
    externalCommentsToCustomer: new Set([ITEM_STATUS.CANCEL]),
    saleText_1: new Set([ITEM_STATUS.CANCEL]),
    saleText_2: new Set([ITEM_STATUS.CANCEL]),
    saleText_3: new Set([ITEM_STATUS.CANCEL]),
    saleText_4: new Set([ITEM_STATUS.CANCEL]),
    remark: new Set([ITEM_STATUS.CANCEL]),
    itemNoteCip: new Set([ITEM_STATUS.CANCEL]),
    prItemTextCip: new Set([ITEM_STATUS.CANCEL]),
    lotNoPp: new Set([ITEM_STATUS.CANCEL]),
    productionMemoPp: new Set([ITEM_STATUS.CANCEL])
  };
  return allowEditMap[id] || new Set([]);
};
